// extracted by mini-css-extract-plugin
export default {"opening":"Opening_opening__kcyFq","times":"Opening_times__Mq-OA"};